export default __webpack_public_path__ + "static/media/it_6.0d3c9ae3.mp3";